// creating the decorator DestroySubscribers
export function DestroyComponentSubs() {  
  return function (target: any) {
    // decorating the function ngOnDestroy
    target.prototype.ngOnDestroy = ngOnDestroyDecorator(target.prototype.ngOnDestroy);

    // decorator function
    function ngOnDestroyDecorator(f) {
      return function () {

        // saving the result of ngOnDestroy performance to the variable superData 
        let superData = f ? f.apply(this, arguments) : null;

        if(this.eventSubscriptions){
          for (let sub of this.eventSubscriptions) {
            sub.unsubscribe();
          }
        }

        // returning the result of ngOnDestroy performance
        return superData;
      }
    }

    // returning the decorated class
    return target;
  }
}